module.exports = __webpack_public_path__ + "static/media/profile-4.3d7a1e49.png";